<template>
  <v-layout text-center>
    <v-container>
      <v-layout row>
        <v-flex xs12 sm6 offset-sm3>
          <v-card>
            <v-toolbar color="blue" dark>
              <v-toolbar-title>Administrators</v-toolbar-title>
            </v-toolbar>

            <v-list two-line>
              <template v-for="(liason, index) in liasons">
                <v-list-tile
                  :key="liason.id"
                  avatar
                  ripple
                  @click="removeAdmin(liason)"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{ liason.fullName }}</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-icon
                      color="grey lighten-1"
                    >
                      mdi-delete
                    </v-icon>

                  </v-list-tile-action>

                </v-list-tile>
                <v-divider
                  v-if="index + 1 < liasons.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-btn
      fab
      bottom
      right
      color="blue"
      dark
      fixed
      class="add-button-bottom"
      @click="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog v-model="dialog" max-width="800px">
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="dialog = !dialog">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add Administrator</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
          <v-btn dark flat @click="saveLiason">Save</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-autocomplete
                  :items="memberList"
                  item-text="fullName"
                  item-value="id"
                  v-model="liason.UserId"
                  label="Member"
                  hide-details
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card v-if="liason.type === 'Group'" class="px-5">
          <v-card-title primary-title>
            <div>
              <div class="title">Committees</div>
            </div>
          </v-card-title>

          <v-card-text>
            <v-list two-line>
              <template v-for="(item, index) in liason.Committees">
                <v-divider
                  v-if="item.divider"
                  :key="index"
                  :inset="item.inset"
                ></v-divider>

                <v-list-tile
                  v-else
                  :key="item.id"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-btn icon ripple @click="deleteMember(item.id)">
                      <v-icon color="red lighten-1">delete</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list>
          </v-card-text>

          <v-card-actions>
            <v-autocomplete
              :items="committeeList"
              v-model="committee"
              label="New Committee"
              hide-details
            ></v-autocomplete>
            <v-spacer></v-spacer>
            <v-btn flat @click="addCommittee">Add Committee</v-btn>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'

export default {
  data: () => ({
    currentPage: 'Settings',
    currentYear: 0,
    userId: 0,
    dialog: false,
    // myId: this.$store.state.user.id,
    isAdmin: false,
    liasons: [],
    liason: {},
    memberList: [],
    committee: {},
    committeeList: [],
    type: [
      { text: 'Group', value: 'Group' },
      { text: 'Officer', value: 'Officer' }
    ],
    snackbar: {
      show: false,
      color: '',
      message: ''
    }
  }),

  created () {
    this.$store.dispatch('setCurrentPage', this.currentPage)
    this.currentYear = this.$store.state.currentYear
    this.isAdmin = this.$store.state.isAdmin
    this.userId = this.$store.state.user.id

    this.currentYear = this.$store.state.currentYear

    this.getAdmins()
    this.getMembers()
    // this.getCommittees()
  },

  watch: {
    dialog (val) {
      if (!val) {
        this.liason = {}
      }
    }
  },

  methods: {
    async getAdmins () {
      try {
        const response = await Api().get('admins')
        this.liasons = response.data
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async getMembers () {
      let allUsers = 'users'

      try {
        const response = await Api().get(allUsers)
        this.memberList = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    editLiason (liason) {
      this.liason = liason
      this.dialog = true
    },

    async saveLiason () {
      try {
        let response = []
        let admin = {}

        const member = this.memberList.find(x => x.id === this.liason.UserId)
        console.log(member)
        admin.id = member.id
        admin.RoleId = 1

        response = await Api().put('admins/' + member.id, admin)

        this.getAdmins()

        this.dialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async removeAdmin (member) {
      try {
        let response = []
        let admin = {}

        console.log(member)
        admin.id = member.id
        admin.RoleId = 0

        response = await Api().put('admins/' + member.id, admin)

        this.getAdmins()

        this.dialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async addCommittee () {
      try {
        const member = {}

        const user = await Api().get('users/' + this.user)

        let phone = user.data.cellPhone.replace(/[^+\d]+/g, '')

        const textAddress = phone + user.data.MobileType.extension

        member.textAddress = textAddress
        member.userId = this.user
        member.userTextId = this.text.id

        const response = await Api().post('text_member', member)

        console.log('member', member)
        this.text.Users.push(user.data)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/settings/Admins.vue